/// <reference path="../../app.definition.ts" />

angular.module('eCareVault.common.factory')
        .factory('pdfjs', ['$window',($window: ng.IWindowService) => $window.pdfjsLib || {}]);

